/**
 * Add helper classes to html tag based on user agent
 * Currently supports apple detection / all other
 * Ex: class="platform-iPhone platform-iPhone-safari"
 */

class PlatformDetection {
    constructor(element) {
        this.element = element;
        let platform;
        let browser;

        // Find device type
        switch (navigator.platform) {
            case 'iPhone': // iPhone Chrome/Safari
                platform = 'iPhone';
                break;
            case 'iPad': // iPad Chrome
            case 'MacIntel': // Ipad Safari
                platform = 'iPad';
                break;
            default:
                platform = 'default';
        }

        // Find browser type
        if ((platform === 'iPhone' || platform === 'iPad') && navigator.userAgent.match(/CriOS/)) {
            browser = 'chrome';
        } else if ((platform === 'iPhone' || platform === 'iPad')) {
            browser = 'safari';
        } else {
            browser = 'default';
        }

        this.element.classList.add(`platform-${platform}`);
        this.element.classList.add(`platform-${platform}--${browser}`);
    }
}

export default PlatformDetection;
